export default __webpack_public_path__ + "alberta-template.49cd3000fd77e0f365aa.svg";